import React from 'react';
import { Meteor } from 'meteor/meteor';
import PropTypes from 'prop-types';
import { withTracker } from 'meteor/react-meteor-data';
import {
  featureGetZoom,
  featurePointGetLongitude,
  featurePointGetLatitude
} from '../../../modules/geojson-utilities';
import Styles from './styles';
// need to add user organization in domain
// how to contruct this url

const webMapiFrame = async (itemId, user, mapCenter) => {
  const footerHeight = 45;
  const navBarHeight = 72;
  const headerHeight = 69 + 30; // in sm
  const totalHeightToRemove = footerHeight + navBarHeight + headerHeight;
  const mapHeight = `calc(100vh - ${totalHeightToRemove}px)`;

  const isOrgUser = true;
  const userDomain = 'pilar-arr';
  let domain = 'www';
  if (isOrgUser) {
    domain = `${userDomain}.maps`;
  }

  const centerQuery = `${featurePointGetLongitude(mapCenter)};${featurePointGetLatitude(
    mapCenter
  )}`;

  const sourceText = `http://${domain}.arcgis.com/home/webmap/viewer.html?webmap=${itemId}&center=${centerQuery}&level=${featureGetZoom(
    mapCenter
  )}&embedded=1&hide=bm,analysis,measure&locale=en-us`;

  return (
    <Styles.EsriWebMap>
      <iframe
        style={{ height: mapHeight }}
        title="esri-web-map"
        id="esri-web-map"
        src={sourceText}
      />
    </Styles.EsriWebMap>
  );
};

const EsriWebMap = ({ loading, itemId, user, mapCenter }) =>
  !loading ? webMapiFrame(itemId, user, mapCenter) : <div />;

EsriWebMap.defaultProps = {
  user: {}
};

EsriWebMap.propTypes = {
  itemId: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  user: PropTypes.object,
  mapCenter: PropTypes.object.isRequired
};

export default withTracker(() => {
  const subscription = Meteor.subscribe('users.editProfile');
  return {
    loading: !subscription.ready(),
    user: Meteor.user()
  };
})(EsriWebMap);
